export const HIDE_CONTENTS_RU = [
  'guides/integrations/whatsapp',
  'guides/integrations/whatsapp-calls',
];
export const HIDE_CONTENTS_NOT_RU: string[] = ['voice-ai/yandex/realtime-client'];
